@if (!authService.isInitialized()) {
  <lib-loader [fullscreen]="true"></lib-loader>
} @else {
  <app-nav />

  <div
    class="container"
    [class.has-side-nav]="authService.isAuthenticated()"
  >
    @if (authService.isAuthenticated()) {
      <app-side-nav />
    }
    <section class="content-view">
      <router-outlet> </router-outlet>
    </section>

    @if (showItcLogo()) {
      <app-footer></app-footer>
    }
    <lib-toaster></lib-toaster>
  </div>
}
